/* Carska: filtry i sortowanie. Zero bibliotek.
   Zmiana w formularzu -> pobranie tej samej sekcji z ?section_id -> podmiana siatki, licznika, pigulek i list filtrow.
   Adres strony aktualizowany przez history.pushState, cofanie dziala. Szuflada mobile: jak panel nawigacji. */
(function () {
  'use strict';
  var doc = document;
  // W trybie lokalnym (data-facets-local) pracuje osobny silnik na dole pliku.
  var root = doc.querySelector('[data-facets-root]:not([data-facets-local])');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var main = root.querySelector('[data-facets-main]');
  var timer = null;
  var ctrl = null;
  var mq = window.matchMedia('(max-width: 1000px)');

  function qs(sel, el) { return (el || root).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }

  /* ---------- parametry ---------- */
  function paramsFromForm(form) {
    var p = new URLSearchParams();
    var fd = new FormData(form);
    fd.forEach(function (v, k) {
      if (v === '' || v === null) return;
      p.append(k, v);
    });
    return p;
  }

  function mergeSort(p) {
    // Formularz sortowania (desktop) i formularz filtrow (kolumna) to dwa formularze: sklej je.
    var sortForm = qs('[data-facets-sort-form]');
    var sideForm = qs('[data-facets-side-form]');
    var drawerForm = qs('[data-facets-drawer-form]');
    var src = mq.matches ? drawerForm : (sideForm || drawerForm);
    var out = src ? paramsFromForm(src) : new URLSearchParams();
    if (!mq.matches && sortForm) {
      out.delete('sort_by');
      var s = sortForm.querySelector('[name="sort_by"]');
      if (s && s.value) out.set('sort_by', s.value);
    }
    if (p) { p.forEach(function (v, k) { out.set(k, v); }); }
    return out;
  }

  /* ---------- render ---------- */
  function openStates() {
    var st = {};
    qsa('[data-fgroup]').forEach(function (d) { st[d.getAttribute('data-fgroup')] = d.open; });
    return st;
  }
  function restoreOpen(st) {
    qsa('[data-fgroup]').forEach(function (d) {
      var k = d.getAttribute('data-fgroup');
      if (k in st) d.open = st[k];
    });
  }

  function render(params, push) {
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&' + params.toString();
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    if (main) main.classList.add('is-loading');

    fetch(url, { signal: ctrl.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tpl = doc.createElement('div');
        tpl.innerHTML = html;
        var fresh = tpl.querySelector('[data-facets-root]');
        if (!fresh) { window.location.search = params.toString(); return; }

        var wasOpen = openStates();
        var drawerOpen = qs('[data-facets-drawer]') && qs('[data-facets-drawer]').classList.contains('is-open');
        var active = doc.activeElement;
        var activeId = active && active.id ? active.id : null;

        // podmiana: pasek, pigulki, kolumna, szuflada (zawartosc), siatka
        ['[data-facets-toolbar]', '[data-facets-pills]', '[data-facets-side]', '[data-facets-main]'].forEach(function (sel) {
          var oldEl = qs(sel), newEl = fresh.querySelector(sel);
          if (oldEl && newEl) oldEl.replaceWith(newEl);
          else if (oldEl && !newEl) oldEl.remove();
          else if (!oldEl && newEl) {
            // pigulki pojawiaja sie po pierwszym filtrze: wstaw po pasku
            var tb = qs('[data-facets-toolbar]');
            if (tb && sel === '[data-facets-pills]') tb.after(newEl);
          }
        });
        var oldDrawerForm = qs('[data-facets-drawer-form]'), newDrawerForm = fresh.querySelector('[data-facets-drawer-form]');
        if (oldDrawerForm && newDrawerForm) oldDrawerForm.replaceWith(newDrawerForm);
        var oldFoot = qs('.ck-facets-drawer-foot'), newFoot = fresh.querySelector('.ck-facets-drawer-foot');
        if (oldFoot && newFoot) oldFoot.replaceWith(newFoot);

        restoreOpen(wasOpen);
        main = qs('[data-facets-main]');
        bind();
        if (drawerOpen) { qs('[data-facets-open]') && qs('[data-facets-open]').setAttribute('aria-expanded', 'true'); }
        if (activeId) { var again = doc.getElementById(activeId); if (again) again.focus({ preventScroll: true }); }

        if (push) {
          var q = params.toString();
          history.pushState({ ck: q }, '', window.location.pathname + (q ? '?' + q : ''));
        }
      })
      .catch(function (e) { if (e.name !== 'AbortError') window.location.search = params.toString(); })
      .finally(function () { if (main) main.classList.remove('is-loading'); });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () { render(mergeSort(null), true); }, delay);
  }

  /* ---------- szuflada ---------- */
  var lastFocus = null;
  function drawer() { return qs('[data-facets-drawer]'); }
  function overlay() { return qs('[data-facets-overlay]'); }
  function openDrawer() {
    var d = drawer(), o = overlay(); if (!d) return;
    lastFocus = doc.activeElement;
    d.inert = false; d.setAttribute('aria-hidden', 'false');
    o && o.classList.add('is-open');
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    doc.body.classList.add('ck-facets-open');
    var btn = qs('[data-facets-open]'); btn && btn.setAttribute('aria-expanded', 'true');
    var first = d.querySelector('select, input:not([type=hidden]):not([disabled]), button');
    setTimeout(function () { (first || d).focus({ preventScroll: true }); }, 320);
  }
  function closeDrawer() {
    var d = drawer(), o = overlay(); if (!d) return;
    d.classList.remove('is-open'); o && o.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true'); d.inert = true;
    doc.body.classList.remove('ck-facets-open');
    var btn = qs('[data-facets-open]'); btn && btn.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- zdarzenia ---------- */
  function onInput(e) {
    var t = e.target;
    if (!t || !t.form || !t.form.hasAttribute('data-facets-form')) return;
    if (t.type === 'number') {
      // 'change' na polu liczbowym odpala sie przy utracie fokusu (np. klik w pigulke) i planowalby
      // stary render, ktory nadpisze klikniecie. Liczy sie tylko 'input' z debounce.
      if (e.type === 'change') return;
      schedule(700); return;
    }
    if (t.name === 'sort_by') { schedule(0); return; }
    schedule(250);
  }
  function onClick(e) {
    var t = e.target.closest('[data-facet-remove], [data-facets-open], [data-facets-close], [data-facets-apply], [data-facets-overlay]');
    if (!t) return;
    if (t.hasAttribute('data-facet-remove')) {
      e.preventDefault(); clearTimeout(timer);
      var u = new URL(t.href, window.location.origin);
      render(u.searchParams, true);
      return;
    }
    if (t.hasAttribute('data-facets-open')) { clearTimeout(timer); openDrawer(); return; }
    if (t.hasAttribute('data-facets-close') || t.hasAttribute('data-facets-overlay')) { closeDrawer(); return; }
    if (t.hasAttribute('data-facets-apply')) { clearTimeout(timer); render(mergeSort(null), true); closeDrawer(); }
  }
  function onSubmit(e) {
    if (e.target && e.target.hasAttribute('data-facets-form')) { e.preventDefault(); clearTimeout(timer); render(mergeSort(null), true); }
  }
  function onKey(e) {
    if (e.key === 'Escape') { var d = drawer(); if (d && d.classList.contains('is-open')) closeDrawer(); }
  }
  function bind() { /* delegacja na root, nic do ponownego wiazania */ }

  root.addEventListener('input', onInput);
  root.addEventListener('change', onInput);
  root.addEventListener('click', onClick);
  root.addEventListener('submit', onSubmit);
  doc.addEventListener('keydown', onKey);
  window.addEventListener('popstate', function (ev) {
    var q = ev.state && typeof ev.state.ck === 'string' ? ev.state.ck : window.location.search.replace(/^\?/, '');
    render(new URLSearchParams(q), false);
  });
  history.replaceState({ ck: window.location.search.replace(/^\?/, '') }, '');
})();

/* ============================================================
   TRYB LOKALNY: filtrowanie w przegladarce, bez Search & Discovery.
   Aktywny gdy [data-facets-root] ma atrybut data-facets-local.
   Zrodlo danych: atrybuty data-kat / data-prz / data-pos / data-price / data-avail
   na kartach produktow. Stan trzymany w adresie strony (?kategoria=...&forma=...).
   ============================================================ */
(function () {
  'use strict';
  var doc = document;
  var root = doc.querySelector('[data-facets-root][data-facets-local]');
  if (!root) return;

  var GROUPS = [
    { key: 'kat', param: 'kategoria', attr: 'data-kat', label: 'Kategoria' },
    { key: 'prz', param: 'przeznaczenie', attr: 'data-prz', label: 'Przeznaczenie' },
    { key: 'pos', param: 'forma', attr: 'data-pos', label: 'Forma' },
    { key: 'av', param: 'dostepnosc', attr: 'data-avail', label: 'Dostępność' }
  ];
  var AV_LABEL = { '1': 'Dostępne', '0': 'Chwilowo niedostępne' };

  function qsa(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  var cards = qsa('[data-prod]');
  var countEl = root.querySelector('[data-facets-count]');
  var emptyEl = root.querySelector('[data-lf-empty]');
  var pillsRow = root.querySelector('[data-facets-pills]');
  var pillsUl = pillsRow ? pillsRow.querySelector('.ck-fpills') : null;

  function cardValues(card, attr) {
    var raw = card.getAttribute(attr) || '';
    return raw ? raw.split('|') : [];
  }

  /* ---------- stan ---------- */
  function readState() {
    var p = new URLSearchParams(window.location.search);
    var st = { pmin: null, pmax: null };
    GROUPS.forEach(function (g) {
      var v = p.get(g.param);
      st[g.key] = v ? v.split('~').filter(Boolean) : [];
    });
    var mn = parseFloat(p.get('cena_od')); if (!isNaN(mn)) st.pmin = mn;
    var mx = parseFloat(p.get('cena_do')); if (!isNaN(mx)) st.pmax = mx;
    return st;
  }

  function writeState(st, push) {
    var p = new URLSearchParams(window.location.search);
    GROUPS.forEach(function (g) {
      if (st[g.key] && st[g.key].length) p.set(g.param, st[g.key].join('~'));
      else p.delete(g.param);
    });
    if (st.pmin !== null && st.pmin !== undefined) p.set('cena_od', st.pmin); else p.delete('cena_od');
    if (st.pmax !== null && st.pmax !== undefined) p.set('cena_do', st.pmax); else p.delete('cena_do');
    var q = p.toString();
    var url = window.location.pathname + (q ? '?' + q : '');
    if (push) history.pushState({ lf: q }, '', url);
    else history.replaceState({ lf: q }, '', url);
  }

  /* ---------- dopasowanie ---------- */
  function matches(card, st, skipKey) {
    for (var i = 0; i < GROUPS.length; i++) {
      var g = GROUPS[i];
      if (g.key === skipKey) continue;
      var want = st[g.key];
      if (!want || !want.length) continue;
      var have = cardValues(card, g.attr);
      var hit = false;
      for (var j = 0; j < want.length; j++) { if (have.indexOf(want[j]) !== -1) { hit = true; break; } }
      if (!hit) return false;
    }
    if (skipKey !== 'price') {
      var zl = parseInt(card.getAttribute('data-price') || '0', 10) / 100;
      if (st.pmin !== null && st.pmin !== undefined && zl < st.pmin) return false;
      if (st.pmax !== null && st.pmax !== undefined && zl > st.pmax) return false;
    }
    return true;
  }

  /* ---------- odmiana ---------- */
  function plural(n) {
    var m10 = n % 10, m100 = n % 100;
    if (n === 1) return 'produkt';
    if (m10 >= 2 && m10 <= 4 && m100 !== 12 && m100 !== 13 && m100 !== 14) return 'produkty';
    return 'produktów';
  }

  /* ---------- render ---------- */
  function apply(st, push) {
    var shown = 0;
    cards.forEach(function (card) {
      var ok = matches(card, st, null);
      card.hidden = !ok;
      if (ok) shown++;
    });

    if (countEl) {
      var total = parseInt(countEl.getAttribute('data-total') || cards.length, 10);
      countEl.textContent = shown === total ? (shown + ' ' + plural(shown)) : (shown + ' z ' + total + ' produktów');
    }
    qsa('[data-facets-count-inline]').forEach(function (e) { e.textContent = shown; });
    qsa('[data-facets-count-word]').forEach(function (e) { e.textContent = plural(shown); });
    if (emptyEl) emptyEl.hidden = shown !== 0;

    // liczniki przy wartosciach: ile zostanie, jesli dolozyc te wartosc
    GROUPS.forEach(function (g) {
      qsa('input[data-lf="' + g.key + '"]').forEach(function (input) {
        var n = 0;
        cards.forEach(function (card) {
          if (!matches(card, st, g.key)) return;
          if (cardValues(card, g.attr).indexOf(input.value) !== -1) n++;
        });
        var lbl = input.closest('.ck-fcheck');
        if (!lbl) return;
        var nEl = lbl.querySelector('.ck-fcheck-n');
        if (nEl) nEl.textContent = n;
        var off = n === 0 && !input.checked;
        lbl.classList.toggle('is-off', off);
        input.disabled = off;
      });
    });

    // liczniki aktywnych na grupach i przycisku
    var activeTotal = 0;
    GROUPS.forEach(function (g) { activeTotal += (st[g.key] || []).length; });
    if (st.pmin !== null && st.pmin !== undefined) activeTotal++;
    else if (st.pmax !== null && st.pmax !== undefined) activeTotal++;

    GROUPS.forEach(function (g) {
      qsa('[data-group-n="' + g.key + '"]').forEach(function (e) {
        var n = (st[g.key] || []).length;
        e.textContent = n; e.hidden = n === 0;
      });
    });
    qsa('[data-group-n="pr"]').forEach(function (e) {
      var on = (st.pmin !== null && st.pmin !== undefined) || (st.pmax !== null && st.pmax !== undefined);
      e.textContent = '1'; e.hidden = !on;
    });
    qsa('[data-active-n]').forEach(function (e) { e.textContent = activeTotal; e.hidden = activeTotal === 0; });
    qsa('[data-lf-clear]').forEach(function (e) { if (e.hasAttribute('hidden') !== (activeTotal === 0)) e.hidden = activeTotal === 0; });

    renderPills(st, activeTotal);
    syncInputs(st);
    writeState(st, push);
  }

  function renderPills(st, activeTotal) {
    if (!pillsUl || !pillsRow) return;
    pillsUl.innerHTML = '';
    if (activeTotal === 0) { pillsRow.hidden = true; return; }
    pillsRow.hidden = false;

    GROUPS.forEach(function (g) {
      (st[g.key] || []).forEach(function (v) {
        var li = doc.createElement('li');
        var a = doc.createElement('button');
        a.type = 'button';
        a.className = 'ck-fpill';
        a.setAttribute('data-lf-pill', g.key);
        a.setAttribute('data-lf-val', v);
        a.innerHTML = '';
        a.appendChild(doc.createTextNode(g.key === 'av' ? (AV_LABEL[v] || v) : v));
        var x = doc.createElement('span');
        x.className = 'ck-fpill-x'; x.setAttribute('aria-hidden', 'true'); x.textContent = '×';
        a.appendChild(x);
        var sr = doc.createElement('span');
        sr.className = 'ck-sr'; sr.textContent = 'Usuń filtr ' + (g.key === 'av' ? (AV_LABEL[v] || v) : v);
        a.appendChild(sr);
        li.appendChild(a); pillsUl.appendChild(li);
      });
    });

    if ((st.pmin !== null && st.pmin !== undefined) || (st.pmax !== null && st.pmax !== undefined)) {
      var li2 = doc.createElement('li');
      var b = doc.createElement('button');
      b.type = 'button'; b.className = 'ck-fpill'; b.setAttribute('data-lf-pill', 'price');
      b.appendChild(doc.createTextNode((st.pmin || 0) + ' zł do ' + (st.pmax !== null && st.pmax !== undefined ? st.pmax : '∞') + ' zł'));
      var x2 = doc.createElement('span');
      x2.className = 'ck-fpill-x'; x2.setAttribute('aria-hidden', 'true'); x2.textContent = '×';
      b.appendChild(x2);
      li2.appendChild(b); pillsUl.appendChild(li2);
    }

    var li3 = doc.createElement('li');
    var c = doc.createElement('button');
    c.type = 'button'; c.className = 'ck-fpill ck-fpill-clear'; c.setAttribute('data-lf-clear', '');
    c.textContent = 'Wyczyść wszystko';
    li3.appendChild(c); pillsUl.appendChild(li3);
  }

  function syncInputs(st) {
    GROUPS.forEach(function (g) {
      qsa('input[data-lf="' + g.key + '"]').forEach(function (input) {
        var on = (st[g.key] || []).indexOf(input.value) !== -1;
        if (input.checked !== on) input.checked = on;
      });
    });
    qsa('input[data-lf="pmin"]').forEach(function (i) {
      var v = (st.pmin === null || st.pmin === undefined) ? '' : String(st.pmin);
      if (i.value !== v && doc.activeElement !== i) i.value = v;
    });
    qsa('input[data-lf="pmax"]').forEach(function (i) {
      var v = (st.pmax === null || st.pmax === undefined) ? '' : String(st.pmax);
      if (i.value !== v && doc.activeElement !== i) i.value = v;
    });
  }

  /* ---------- zdarzenia ---------- */
  var state = readState();
  var priceTimer = null;

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.hasAttribute || !t.hasAttribute('data-lf')) return;
    var kind = t.getAttribute('data-lf');
    if (kind === 'pmin' || kind === 'pmax') return;
    var g = GROUPS.filter(function (x) { return x.key === kind; })[0];
    if (!g) return;
    var arr = state[g.key] || [];
    var i = arr.indexOf(t.value);
    if (t.checked && i === -1) arr.push(t.value);
    if (!t.checked && i !== -1) arr.splice(i, 1);
    state[g.key] = arr;
    apply(state, true);
  });

  root.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.hasAttribute || !t.hasAttribute('data-lf')) return;
    var kind = t.getAttribute('data-lf');
    if (kind !== 'pmin' && kind !== 'pmax') return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(function () {
      var v = parseFloat(t.value);
      var key = kind === 'pmin' ? 'pmin' : 'pmax';
      state[key] = isNaN(v) ? null : v;
      apply(state, true);
    }, 400);
  });

  root.addEventListener('click', function (e) {
    var clear = e.target.closest('[data-lf-clear]');
    if (clear) {
      e.preventDefault();
      GROUPS.forEach(function (g) { state[g.key] = []; });
      state.pmin = null; state.pmax = null;
      apply(state, true);
      return;
    }
    var pill = e.target.closest('[data-lf-pill]');
    if (pill) {
      e.preventDefault();
      var key = pill.getAttribute('data-lf-pill');
      if (key === 'price') { state.pmin = null; state.pmax = null; }
      else {
        var v = pill.getAttribute('data-lf-val');
        state[key] = (state[key] || []).filter(function (x) { return x !== v; });
      }
      apply(state, true);
    }
  });

  window.addEventListener('popstate', function () {
    state = readState();
    apply(state, false);
  });

  /* ---------- szuflada mobilna ---------- */
  var lastFocus = null;
  function drawer() { return root.querySelector('[data-facets-drawer]'); }
  function overlay() { return root.querySelector('[data-facets-overlay]'); }
  function openDrawer() {
    var d = drawer(), o = overlay(); if (!d) return;
    lastFocus = doc.activeElement;
    d.inert = false; d.setAttribute('aria-hidden', 'false');
    if (o) o.classList.add('is-open');
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    doc.body.classList.add('ck-facets-open');
    var btn = root.querySelector('[data-facets-open]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    setTimeout(function () {
      var first = d.querySelector('select, input:not([type=hidden]):not([disabled]), button');
      (first || d).focus({ preventScroll: true });
    }, 320);
  }
  function closeDrawer() {
    var d = drawer(), o = overlay(); if (!d) return;
    d.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true'); d.inert = true;
    doc.body.classList.remove('ck-facets-open');
    var btn = root.querySelector('[data-facets-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-facets-open]')) { openDrawer(); return; }
    if (e.target.closest('[data-facets-close], [data-facets-overlay], [data-facets-apply]')) { closeDrawer(); }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = drawer();
    if (d && d.classList.contains('is-open')) closeDrawer();
  });

  /* ---------- sortowanie: przeladowanie serwerowe, filtry wracaja z adresu ----------
     Cena i data sortuja sie natywnie w Shopify (sort_by w URL, zweryfikowane na zywo).
     "Domyslne" (manual) i "Najczesciej wybierane" (best-selling) nie maja w Shopify
     sensownych danych, wiec kolejnosc ustala carska-collection.liquid inline jako CSS
     `order` z metapol custom.default_order / custom.popularity_rank. Tu wystarczy
     przeladowanie z nowym sort_by - siatka wraca juz w dobrej kolejnosci. ---------- */
  root.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.name || sel.name !== 'sort_by') return;
    var p = new URLSearchParams(window.location.search);
    p.set('sort_by', sel.value);
    window.location.search = p.toString();
  });

  /* ---------- gestosc siatki: 1 albo 2 produkty w rzedzie (mobile/tablet) ---------- */
  var DENSITY_KEY = 'ck-cols';

  function applyDensity(cols) {
    root.classList.toggle('is-cols-1', cols === '1');
    qsa('[data-density]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-density') === cols ? 'true' : 'false');
    });
  }

  var startCols = '2';
  try { startCols = window.localStorage.getItem(DENSITY_KEY) || '2'; } catch (err) { startCols = '2'; }
  if (startCols !== '1' && startCols !== '2') startCols = '2';
  applyDensity(startCols);

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-density]');
    if (!btn) return;
    var cols = btn.getAttribute('data-density');
    applyDensity(cols);
    try { window.localStorage.setItem(DENSITY_KEY, cols); } catch (err) { /* tryb prywatny */ }
  });

  apply(state, false);
})();
